import React, { useEffect, useState } from "react";
import axios from "axios";
import { URL_API } from "../variable";
import {
  ClimbingBoxLoader,
  BounceLoader,
  BarLoader,
  BeatLoader,
} from "react-spinners";
import { css } from "@emotion/react";

import {
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Table,
  Row,
  Col,
  Pagination,
} from "reactstrap";
import moment from "moment";

import ReactPaginate from "react-paginate";
import { useParams } from "react-router";

function RefferedAmount() {
  const loaderCss = css`
    margin: auto;
  `;
  const [customers, setCustomers] = useState([]);
  const [loading, setloading] = useState([]);

  const [offset, setOffset] = useState(0);
  const [perPage] = useState(10);
  const [pageCount, setPageCount] = useState(0);
  const userId = useParams();
  console.log("userId", userId);

  useEffect(() => {
    getCustomers();
    setloading(true);
  }, []);

  const handlePageClick = (e) => {
    const selectedPage = e.selected;
    setOffset(selectedPage + 1);
  };

  const getCustomers = () => {
    axios.get(URL_API + "customers/referals").then((response) => {
      console.log("refereddfafasdfasdfads", response.data[0].refer_by[0]);
      if (response.request.status === 200) {
        setCustomers(response.data);
        setloading(false);
      }
    });
  };
  // console.log("customers", customers);
  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Reffered Amount History</CardTitle>
              </CardHeader>
              <CardBody>
                <Table responsive>
                  <thead className="text-primary">
                    <tr>
                      <th>#</th>
                      <th>Transfer To</th>
                      <th>Phone</th>
                      <th>Transfer Amount</th>
                      <th>Befor Transfer</th>
                      <th>E Money Total</th>
                      <th>Transfer By</th>
                      <th>Created At</th>
                      {/* <th className="text-right">Action</th> */}
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <div>
                        <BeatLoader
                          css={loaderCss}
                          size="12"
                          color="#4cd964"
                          marginLeft="500px"
                          marginTop="500px"
                          loading
                        />
                        <br />
                        <br />
                      </div>
                    ) : (
                      customers.map(
                        (riders, index) => {
                          return (
                            <>
                              {riders.id == userId.id ? (
                                <>
                                  {riders?.transfer_by_amount?.map(
                                    (referredBy, index) => {
                                      return (
                                        <tr>
                                          <td>{index + 1}</td>
                                          <td>
                                            {riders?.id ==
                                            referredBy?.transfer_to ? (
                                              <>{riders?.name}</>
                                            ) : (
                                              ""
                                            )}
                                          </td>
                                          <td>{riders?.phone_number}</td>
                                          <td>{referredBy?.amount} Rs</td>
                                          <td>---</td>
                                          <td>{riders?.e_money}</td>
                                          <td>{referredBy?.transfer_by}</td>
                                        
                                          <td>
                                            {moment(referredBy?.created_at).format(
                                              " DD/MMMM/YYYY, h:mm a"
                                            )}
                                          </td>
                                        </tr>
                                      );
                                    }
                                  )}
                                </>
                              ) : null}
                            </>
                          );
                        }
                        // )
                      )
                    )}
                  </tbody>
                </Table>
                {/* <ReactPaginate
                    previousLabel={"prev"}
                    nextLabel={"next"}
                    breakLabel={"..."}
                    breakClassName={"break-me"}
                    pageCount={pageCount}
                    marginPagesDisplayed={2}
                    pageRangeDisplayed={5}
                    onPageChange={handlePageClick}
                    containerClassName={"pagination"}
                    subContainerClassName={"pages pagination"}
                    activeClassName={"active"}/> */}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default RefferedAmount;
